import { render } from "./PaymentGivingForm2.vue?vue&type=template&id=db787444&scoped=true"
import script from "./PaymentGivingForm2.vue?vue&type=script&lang=js"
export * from "./PaymentGivingForm2.vue?vue&type=script&lang=js"

import "./PaymentGivingForm2.vue?vue&type=style&index=0&id=db787444&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db787444"]])

export default __exports__